import React from 'react'

import { AnalyticsCardWrapper } from '../../components/AnalyticsCardWrapper/AnalyticsCardWrapper'
import {
  useAverageOrderValueReportCard,
  useContributionsPerTypeReportCard,
  usePaymentMethodUsedReportCard,
  useSalesByCountryReportCard,
  useSalesBySourceReportCard,
  useTopProductsByUnitsSoldReportCard,
  useTotalProfitReportCard,
} from '../../hooks/reportCards'

export const DefaultAnalytics = () => {
  const totalProfitReportCard = useTotalProfitReportCard({
    type: 'total',
    headerLabel: 'Profit',
  })
  const totalOrdersReportCard = useContributionsPerTypeReportCard({
    type: 'total',
    headerLabel: 'Orders',
  })
  const averageOrderValueReportCard = useAverageOrderValueReportCard()
  const topProductsByUnitsSoldReportCard = useTopProductsByUnitsSoldReportCard()
  const salesByCountryReportCard = useSalesByCountryReportCard()
  const salesByTrafficSourceReportCard = useSalesBySourceReportCard({
    source: 'traffic_source',
  })
  const salesBySocialPlatformReportCard = useSalesBySourceReportCard({
    source: 'social_platform',
  })
  const paymentMethodUsedReportCard = usePaymentMethodUsedReportCard()

  return (
    <>
      <AnalyticsCardWrapper {...totalProfitReportCard} />
      <AnalyticsCardWrapper {...totalOrdersReportCard} />
      <AnalyticsCardWrapper {...averageOrderValueReportCard} />
      <AnalyticsCardWrapper {...topProductsByUnitsSoldReportCard} />
      <AnalyticsCardWrapper {...salesByCountryReportCard} />
      <AnalyticsCardWrapper {...salesByTrafficSourceReportCard} />
      <AnalyticsCardWrapper {...salesBySocialPlatformReportCard} />
      <AnalyticsCardWrapper {...paymentMethodUsedReportCard} />
    </>
  )
}
